<template>
  <div v-show="news.idt_aff_campaign_news">
    <Breadcrumb :collection="breadcrumbCollection" />
    <b-container class="mb-5">
        <img
          :src="advertiser.thumbnail_url"
          :alt="`Logotipo de ${pageAdvertiser.name}`"
          class="d-block mx-auto news-advertiser-logo"/>
        <h1 class="news-title">{{ news.title }}</h1>
        <h5 class="news-subtitle">{{ news.subtitle }}</h5>
        <div class="news-cover">
          <div v-if="news.video_url" class="video-embedd">
              <iframe
                frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
                type="text/html" :src="getEmbedUrl(news.video_url)">
              </iframe>
          </div>
          <img v-else-if="news.news_image" :src="news.news_image" :alt="news.title">
        </div>
        <div v-if="news.created_at" class="news-date">
          {{ dateFormatter(news.created_at) }}
          <span v-if="!news.updated_at"> · {{ dateTimeAgo(news.created_at) }}</span>
          <span v-else > · Atualizado {{ dateTimeAgo(news.updated_at) }}</span>
        </div>
        <div v-html="news.news_content" class="news-content"></div>
        <news-list v-if="newsId" :news_id="newsId" :is_other_news="true"
          :idtAdvertiser="advertiser.id" :advertiserCode="advertiserCode"/>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NewsApi from '@/services/news';
import Tracker from '@/services/tracker';
import { getStringFromDate, getDateTimeAgo } from '@/utils/dateUtils';
import NewsList from '@/views/NewsList';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'News',
  data() {
    return {
      advertiser: {},
      news: {},
      newsCode: null,
      advertiserCode: null,
      newsId: null,
      breadcrumbCollection: [],
    };
  },
  computed: {
    ...mapGetters(['allAdvertisersDetails', 'affiliateAdvertisers', 'pageAdvertiser']),
  },
  components: {
    'news-list': NewsList,
    Breadcrumb,
  },
  methods: {
    ...mapActions(['fetchAdvertiser']),
    dateFormatter(value) {
      return getStringFromDate(new Date(value));
    },
    dateTimeAgo(value) {
      return getDateTimeAgo(value);
    },
    getEmbedUrl(url) {
      const videoUrl = new URL(url);
      return `https://www.youtube.com/embed/${videoUrl.searchParams.get('v')}?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0`;
    },
    removeAccents(word) {
      return word.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },
    async loadAdvertiser(advertiserCode) {
      let advertiser = this.allAdvertisersDetails[advertiserCode];
      if (!advertiser) {
        await this.fetchAdvertiser(advertiserCode);
        advertiser = this.allAdvertisersDetails[advertiserCode];
      }
      this.advertiser = advertiser;
    },
    async loadArticle() {
      const r = await NewsApi.getNews(this.newsCode);
      const toRedirect = `https://afiliados.uol.com.br/app/campanha/${this.advertiserCode}`;
      if (r.newsList && r.newsList.length > 0) {
        const [news] = r.newsList;
        if (this.advertiser.id === news.idt_comm_event_source_group) {
          this.news = news;
          this.newsId = news.idt_aff_campaign_news;
          Tracker.track(`Acessou a notícia: ${this.newsCode} - ${this.advertiserCode}`, 'Acesso');
        } else {
          window.location.href = toRedirect;
        }
      } else {
        window.location.href = toRedirect;
      }
    },
    async isApprovedTo(code) {
      const codes = this.affiliateAdvertisers.map(ad => ({
        sourceName: this.removeAccents(
          ad.desCommissionEventSourceGroup.replace(/\s|-|\+/g, '').toLowerCase(),
        ),
        idtCommissionEventSourceGroup: ad.idtCommissionEventSourceGroup,
        indStatus: ad.indStatus,
      }));
      const advertiser = codes.find(x => x.sourceName === code);
      if (!advertiser || advertiser.indStatus !== 'A') {
        window.location.href = 'https://afiliados.uol.com.br/app/campanhas';
      }
    },
    isFormatPresent(formats) {
      return this.advertiser?.campaigns?.some(c => c.formats.some(fmt => formats.includes(fmt.id)));
    },
    showAdvertiserInfoRules() {
      this.$refs.advertiserInfo.openRulesModal();
    },
    setBreadCrumb() {
      this.breadcrumbCollection = [
        { name: 'Campanhas', url: '/campanhas' },
        { name: this.advertiser.name, url: `/campanha/${this.advertiser.code}` },
        { name: 'Novidades', url: `/campanha/${this.advertiser.code}/novidades` },
        { name: this.news.title, url: '' },
      ];
    },
  },
  async created() {
    this.newsCode = this.$route.params.newsCode.toString();
    this.advertiserCode = this.$route.params.code.toString();

    await this.loadAdvertiser(this.advertiserCode);
    await this.loadArticle();
    this.setBreadCrumb();

    document.querySelector('title').innerHTML = `${this.news.title} - UOL Afiliados`;
  },
  watch: {
    '$route.params.newsCode': {
      handler() {
        this.$router.go();
        window.history.scrollRestoration = 'manual';
      },
    },
  },
};
</script>

<style lang="scss">
  .news-title {
    text-align: center;
    font-family: UOLtext;
    font-weight: bold;
    font-size: 30px;
    color: black;
  }

  .news-cover {
    background-color: gainsboro;
    display: flex;
    justify-content: center;

    img {
      object-fit: cover;
      width: auto;
      max-width: 100%;
      height: 400px;

      @media screen and (max-width: $md) {
        height: 200px;
      }
    }
  }

  .video-embedd {
    display: flex;
    justify-content: center;

    iframe {
      width: 800px;
      height: 433px;

      @media screen and (max-width: $md) {
        width: 590px;
        height: 290px;
      }
    }
  }

  .news-subtitle {
    text-align: center;
    font-family: UOLtext;
    font-size: 15px;
    color: black;
    margin-bottom: 30px;
  }

  .news-date {
    font-family: UOLtext;
    margin: 30px 0;
    font-size: 14px;
    font-weight: bold;

    span {
      font-weight: 300;
    }
  }

  .news-content {
    font-family: UOLtext;
    font-size: 15px;
    text-align: justify;

    figure {
      margin: 10px;
      text-align: center;

      img {
        max-width: 100%;
      }

      div[data-oembed-url] {
        width: 80%;

        @media screen and (max-width: $md) {
          width: 100%;
        }

        margin: 10px auto;
      }
    }

    figcaption {
      padding: 5px;
      font-weight: 300;
    }
  }
</style>
